import { browserOnly } from './browserOnly';

export function navigateTo(url: string) {
  browserOnly(window => {
    window.history.pushState({}, '', url);
    window.history.go(0);
  });
}
